export const volumes = [
  {
    number: 'I',
    title: 'The Root Movement Foundation',
    subtitle: 'Understand the Biomechanics Behind Controlled Orthodontic Torque',
    intro: 'Stop treating every change in tooth inclination as the same type of movement.',
    items: [
      'Crown tipping versus root movement.',
      'Centers of resistance and rotation.',
      'Force systems and moment-to-force relationships.',
      'Controlled versus uncontrolled tipping.',
      'Translational movement and torque expression.',
      'Biological and anatomical considerations.',
    ],
    outcome: 'A clearer understanding of the biomechanical principles needed to evaluate torque-related movements.',
  },
  {
    number: 'II',
    title: 'The Torque Diagnosis Roadmap',
    subtitle: 'Learn How to Evaluate Root Position Before Planning Movement',
    intro: 'Before deciding how to move a tooth, you need to understand its current position and the intended clinical objective.',
    items: [
      'Clinical evaluation of tooth inclination.',
      'Root-position considerations.',
      'Periodontal and alveolar limitations.',
      'Appropriate interpretation of diagnostic records.',
      'Identifying challenging torque requirements.',
      'Recognizing when additional evaluation is necessary.',
    ],
    outcome: 'A structured approach to identifying torque requirements and relevant clinical limitations.',
  },
  {
    number: 'III',
    title: 'The Force System Blueprint',
    subtitle: 'Understand How Orthodontic Mechanics Influence Root Movement',
    intro: 'Learn to evaluate the mechanical principles behind torque-control strategies.',
    items: [
      'Force couples and rotational moments.',
      'Anchorage requirements.',
      'Force application and movement patterns.',
      'Biomechanical differences between appliance systems.',
      'Common causes of unwanted tipping.',
      'Limitations of predicted root movement.',
    ],
    outcome: 'Greater confidence interpreting the forces involved in planned orthodontic movements.',
  },
  {
    number: 'IV',
    title: 'The Attachment & Auxiliary Mechanics Atlas',
    subtitle: 'Evaluate the Tools Used to Support Torque-Control Strategies',
    intro: 'Different clinical situations may require different mechanical approaches.',
    items: [
      'Attachment design considerations.',
      'Power ridges and their limitations.',
      'Auxiliary mechanics.',
      'Anchorage reinforcement.',
      'Clear aligner versus fixed-appliance considerations.',
      'Factors influencing appliance selection.',
    ],
    outcome: 'A practical reference for evaluating mechanical options without assuming that one technique works for every case.',
  },
  {
    number: 'V',
    title: 'The Advanced Torque Planning Roadmap',
    subtitle: 'Organize Your Approach to Challenging Root-Movement Scenarios',
    intro: 'Move beyond basic concepts and learn how to structure the evaluation of more demanding cases.',
    items: [
      'Anterior torque considerations.',
      'Root control during incisor retraction.',
      'Torque planning in extraction cases.',
      'Posterior anchorage considerations.',
      'Movement sequencing.',
      'Clinical scenarios requiring additional mechanics or specialist assessment.',
    ],
    outcome: 'A clearer framework for analyzing complex torque-related treatment objectives.',
  },
  {
    number: 'VI',
    title: 'The Torque Verification & Finishing Protocol',
    subtitle: 'Evaluate Planned Versus Observed Movement Before Finalizing Treatment',
    intro: 'Planning is only part of the process. You also need to recognize when the clinical response differs from the intended movement.',
    items: [
      'Monitoring torque-related movement.',
      'Recognizing unwanted tipping.',
      'Reviewing planned versus observed tooth positions.',
      'Identifying possible tracking discrepancies.',
      'Evaluating when treatment reassessment is necessary.',
      'Documenting finishing objectives and unresolved concerns.',
    ],
    outcome: 'A structured approach to monitoring torque-related objectives throughout treatment.',
  },
];
